import { render, staticRenderFns } from "./PostEmployer.vue?vue&type=template&id=e5f74f2a&"
import script from "./PostEmployer.vue?vue&type=script&lang=js&"
export * from "./PostEmployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports